<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px;"
>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
    >
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >

        <template v-slot:item.time_date="{ item }">
            {{$rc.pretty(item.time, 'date')}}
        </template>

        <template v-slot:item.time_time="{ item }">
            {{$rc.pretty(item.time, 'time')}}
        </template>

        <template v-slot:item.action_menu="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickViewInCrm(item)"
                    v-if="item.url_view_in_crm != null"
                >
                    <v-list-item-title>View in {{crm_name}}...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickTechnicalData(item)"
                >
                    <v-list-item-title>Technical Details...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <div
        v-if="false && $route.params.content_type == 'commerce7'"
        style="margin-top: 15px"
    >
        <p>
            If RedChirp is automatically applying consent tags to customers <b>check to make sure that you have the latest version of the RedChirp Commerce7 app installed</b>
        </p>
    </div>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {

    data() {
        return {
            full_text: null,
            results: [],
            has_at_least_one_tag_with_meaning: true,

            headers: [
                { text: 'Brand', value: 'brand_label'},
                { text: 'Date', value: 'time_date'},
                { text: 'Time', value: 'time_time'},
                { text: 'First Name', value: 'first_name'},
                { text: 'Last Name', value: 'last_name'},
                { text: 'Tag', value: 'tag_label'},
                { text: 'Change', value: 'action'},
                { text: 'Action', value: 'action_menu'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest(
                'LIST: /api/v1/integrations/crm/tag-customer-change-log',
            
                {
                    'full_text': this.full_text,
                    'organization_id' : this.$route.params.organization_id,
                    'content_type' : this.$route.params.content_type,
                },
            
                (data) => {
                    this.results = data.results;
                    this.has_at_least_one_tag_with_meaning = data.has_at_least_one_tag_with_meaning;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to search tag change log');
                },
            );
        },

        onClickViewInCrm(item)
        {
            window.open(item.url_view_in_crm,"_blank");
        },

        onClickTechnicalData(item)
        {
            this.$rc.copy_code_dialog({
                    'title': 'Technical Details',
                    'object': item,
                });
        },
    },

    computed: {
        title() {
            return 'Search '+this.$rc.pretty(this.$route.params.content_type, 'enum_integration_name')+' Tag Change Log';
        },

        crm_name() {
            return this.$rc.pretty(this.$route.params.content_type, 'enum_integration_name');
        }
    },
}
</script>

<style lang="scss" scoped>
</style>